/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import { Container } from 'flux/utils';

import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import DriveBy from 'lib/DriveBy';
import Electron from 'lib/Electron';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import { getGooglePlayShortLink } from 'utils/getGooglePlayLink';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import List from 'components/List.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import SupportDialog from 'support/components/SupportDialog.jsx';
import userAgent from 'lib/currentUserAgent';

import './styles/Header.scss';

type Props = {
  location: Object,
  showNavigation: boolean,
  className?: string,
};

class Header extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  static getStores() {
    return [
      CurrentUser,
    ];
  }

  static defaultProps = {
    showNavigation: true,
  }

  static calculateState() {
    return {
      user: CurrentUser.isSignedIn() ? CurrentUser.getUser() : null,
    };
  }

  handleDriveBy = () => {
    return new DriveBy(ReactDOM.findDOMNode(this));
  }

  renderAuthenticatedNavigation() {
    return (
      <nav className="Header-navigation">
        {this.renderHelpButton()}
      </nav>
    );
  }

  renderHelpButton() {
    return (
      <List className="Header-secondaryNav" horizontal>
        <li>
          <ModalTrigger modal={<SupportDialog />}>
            <Button
              level="text"
              tooltip="Help"
              tooltipPlacement="bottom">
              <Glyph name="help" solo />
            </Button>
          </ModalTrigger>
        </li>
      </List>
    );
  }

  renderBrand() {
    const props = {
      className: 'Header-brandLink',
      onDragEnd: this.handleDriveBy,
    };

    const { router } = this.context;
    if (router.isActive('/setup')) {
      return <div {...props}>Remind</div>;
    }

    if (this.state.user) {
      return <Link {...props} to="/classes">Remind</Link>;
    } else {
      return (
        <Link
          {...props}
          href={LinkConstants.MARKETING}
          target={Electron.isAvailable() ? '_blank' : null}>
          Remind
        </Link>
      );
    }
  }

  renderMobileNavigation() {
    const link = userAgent.android() ? getGooglePlayShortLink() : LinkConstants.APP_DOWNLOAD;

    return (
      <nav className="Header-navigation">
        <Button
          className="Header-button"
          href={link}
          size="small"
          eventElementName="Header-button">
          Get the app
        </Button>
      </nav>
    );
  }

  renderNavigation() {
    if (this.state.user) {
      if (userAgent.phone()) {
        return this.renderMobileNavigation();
      } else {
        return this.renderAuthenticatedNavigation();
      }
    } else {
      return this.renderUnauthenticatedNavigation();
    }
  }

  renderUnauthenticatedNavigation() {
    const { router } = this.context;

    // redirect here on authentication, unless here is the "Sign Out" page
    const skipRedirect = (
      router.isActive('/log_in') ||
      router.isActive('/log_out') ||
      router.isActive('/forgot_password') ||
      router.isActive('/reset_password') ||
      router.isActive('/confirm_email') ||
      router.isActive('/send_the_app') ||
      router.isActive('/share_remind')
    );

    const query = skipRedirect ?
      null :
      Object.assign({ locationOnAuth: this.props.location.pathname }, this.props.location.query);

    const signupTarget = Electron.isAvailable() ? '_blank' : null;

    // FIXME observe locationOnAuth query in "Sign up" case too.
    // Right now it requires `href` because it's in MARKETING, which has no locationOnAuth.
    const conditionalProps = router.isActive('/log_in') ?
      { children: 'Sign up', href: LinkConstants.SIGN_UP, target: signupTarget } :
      { children: 'Log in', to: { pathname: '/log_in', query } };

    return (
      <nav className="Header-navigation">
        {router.isActive('/log_in') && this.renderHelpButton()}
        <Button
          className="Header-button"
          size="small"
          {...conditionalProps}
          eventElementName="Header-button"
        />
      </nav>
    );
  }

  render() {
    return (
      <header
        className={cx('Header', getPropClassesFromInstance(this), this.props.className)}>
        <FlexibleBlock flex="right">
          {this.renderBrand()}
          {this.props.showNavigation ? this.renderNavigation() : null}
        </FlexibleBlock>
      </header>
    );
  }
}

export default Container.create(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx